// extracted by mini-css-extract-plugin
export default {"userMenu":"UserBar_userMenu__ACfQT","nickName":"UserBar_nickName__H36XH","statistic":"UserBar_statistic__nDmUk"};